import {Component, ComponentRef, inject, Injector, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {RetranslationViewModel} from "../Models/RetranslationViewModel";
import {ObjectLiteViewModel} from "../../../../models/ObjectLiteViewModel";
import {ObjectsService} from "../../../../services/objects.service";
import {BaseComponentWithDialog} from "../../base-admin-panel/base-component-with-dialog";
import {TranslateService} from "@ngx-translate/core";
import {ObjectsManagementDialogComponent} from "../../objects-management-dialog/objects-management-dialog.component";
import {DialogService} from "../../../../services/dialog.service";
import {ObjectRetranslationModel} from "../Models/ObjectRetranslationModel";

@Component({
    selector: 'app-object-mgmnt',
    templateUrl: './object-mgmnt.component.html',
    styleUrls: ['./object-mgmnt.component.css'],
    standalone: false
})
export class ObjectMgmntComponent extends BaseComponentWithDialog implements OnInit {

  @ViewChild("objectsListDialog", {read: ViewContainerRef, static: true}) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;


  @Input()
  protected model: RetranslationViewModel;
  public Objects: Map<number, ObjectLiteViewModel>;

  public constructor(protected injector: Injector,
                     protected objectsService: ObjectsService,
                     private translate: TranslateService,
                     protected dialogService: DialogService) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();

    // TODO: add into objects controller action to get a batch of objects by their IDs
    this.objectsService.GetLiteObjects().subscribe((objects: ObjectLiteViewModel[]) => {
      this.Objects = new Map(
        objects.map(o => [o.Id, o])
      );

      this.model.Objects = this.model.Objects.map(item => {
        let obj = this.Objects.get(item.ObjectId);
        let overridenId =  item.OverridenId ?? parseInt(obj.IMEI);
        if (overridenId === 0)
          overridenId = null;
        item.OverridenId = overridenId;
        return item;
      });
    });
  }

  public onRemoveAllClick() {
    if (confirm(this.translate.instant("Clear") + "?"))
      this.model.Objects = [];
  }

  public overridenIdChange(event: any, item: ObjectRetranslationModel) {
    item.OverridenId = event.target.value === '' ? undefined : event.target.value;
  }

  public onAddObjectClick() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      let arr = Array.from(this.Objects).map(x => x[1]);
      this.objectsListDialog.instance.objects = arr
        .filter(o => !this.model.getObjectIds().includes(o.Id))
        .map(obj => {
          return {
            Id: obj.Id,
            Name: obj.Name,
            IsChecked: false
          };
      });
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {
      this.objectsListDialog.instance.objects.forEach(obj => {
        if (obj && obj.IsChecked) {
          let overridenId = this.Objects.get(obj.Id).IMEI;
          if (parseInt(overridenId) === 0)
            overridenId = null;

          this.model.Objects.push(new ObjectRetranslationModel({
            objectId: obj.Id,
            overridenId: overridenId
          }));
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }

  public removeObject(objectId: number) {
    let idx = this.model.getObjectIds().indexOf(objectId);
    if (idx >= 0) {
      this.model.Objects.splice(idx, 1);
    }
  }
}
